import { useEffect, useMemo, useState } from "react";
import { StyledTableBisManualPag } from "@/components/styled/StyledTableBisManualPag";
import usePagination from "@/hooks/useSyncedPagination";
import { useDeletedInvoiceTableColumns } from "./deletedInvoiceTableColumns";
import { InvoiceToBeValidatedFilter } from "../invoicesToBeValidatedTab/invoiceToBeValidatedFilter";
import { RestoreInvoiceModal } from "./restoreInvoiceModal";
import { useGetInvoiceBoV1 } from "@/api/invoice";
import { useDisplayDocument } from "@/hooks/useDisplayDocument";
import { InvoiceStatusEnum } from "@/constants/enums/invoiceStatus.enum";

export const DeletedInvoiceTable = () => {
  const [searchField, setSearchField] = useState<string>("");
  const [pagination, setPagination] = usePagination("invoiceToBeValidatedBo");
  const [invoiceDeleteModal, setInvoiceDeleteModal] = useState<string | null>(null);

  const { displayDocument } = useDisplayDocument();

  const deletedAfter = useMemo(
    () => new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    [],
  );

  const { data: invoices } = useGetInvoiceBoV1({
    invoiceId: searchField ? searchField : undefined,
    businessName: searchField ? searchField : undefined,
    status: [InvoiceStatusEnum.DELETED],
    deletedAfter: deletedAfter,
    take: pagination.pageSize,
    skip: pagination.pageIndex * pagination.pageSize,
  });

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }));
  }, [setPagination, searchField]);

  const columns = useDeletedInvoiceTableColumns(displayDocument, setInvoiceDeleteModal);

  return (
    <>
      <div className="flex w-full flex-col justify-between gap-4 md:flex-row">
        <InvoiceToBeValidatedFilter searchField={searchField} setSearchField={setSearchField} />
      </div>
      <StyledTableBisManualPag
        data={invoices?.data || []}
        columns={columns}
        setPagination={setPagination}
        pagination={pagination}
        rowCount={invoices?.count || 0}
      />
      <RestoreInvoiceModal closeModal={() => setInvoiceDeleteModal(null)} id={invoiceDeleteModal} />
    </>
  );
};
